module.exports = __webpack_public_path__ + "static/img/erweima.6ec2535e.jpg";